<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
   let axisData = [ ""]
   let seriesData = [[75],[15]]

    this.state.chart.setOption({
       tooltip: {
          show: false,
          formatter: "{b} <br> {c}%",
      },
      legend: {
          bottom: "10%",
          left: "center",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 50,
          textStyle: {
            color: "#fff",
            fontSize: 13,
            padding: [0, 0, 0, 15],
          },
          data: [{name: "良好"}, { name: "故障",}],
      },
      xAxis: [
          {
            type: "value",
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: false,
            },
            splitLine: {
                show: false,
            },
          },
      ],
      grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "5%",
          //是否包含坐标轴
          containLabel: true,
          //鼠标滑过是否显示信息栏，目前来看最好在grid中配置tooltip鼠标滑过信息栏
      },
      yAxis: [
          {
            inverse: true,
            splitNumber: 5, // 坐标轴的分割段数，是一个预估值，实际显示会根据数据稍作调整。
            interval: 5, // 强制设置坐标轴分割间隔。
            //type: 'category',
            data: axisData,
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
                lineStyle: {
                  width: 2,
                  color: "#23AEEB",
                },
            },
            axisLabel: {
                textStyle: {
                  fontSize: 22,
                  fontWeight: "bold",
                  color: "#fff",
                },
            },
          },
      ],
      series: [
          {
            name: "良好",
            type: "bar",
            barWidth: 12,
            stack: "危货种类占比",
            label: {
                normal: {
                  width: 62,
                  height: 20,
                  distance: 20,
                  align: "center",
                  verticalAlign: "middle",
                  borderRadius: 5,
                  backgroundColor: "#07DEAD",
                  show: true,
                  fontSize: 13,
                  position: "top",
                  formatter: "{c}%",
                  color: "#fff",
                  // fontWeight: "bold",
                },
            },
            itemStyle: {
                normal: {
                  color: {
                      type: "bar",
                      colorStops: [
                        {
                            offset: 0,
                            color: "#07DEAD", // 0% 处的颜色
                        },
                        {
                            offset: 1,
                            color: "#07DEAD", // 100% 处的颜色
                        },
                      ],
                      shadowBlur: 6,
                      shadowOffsetX: 3,
                      shadowColor: "rgba(255,255,255,0.54)",
                      globalCoord: false, // 缺省为 false
                  },
                },
            },
            data: seriesData[0],
          },
          {
            name: "故障",
            type: "bar",
            barWidth: 12,
            stack: "危货种类占比",
            itemStyle: {
                color: {
                  type: "bar",
                  colorStops: [
                      {
                        offset: 0,
                        color: "#FA7332", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#FA7332", // 100% 处的颜色
                      },
                  ],
                  globalCoord: false, // 缺省为 false
                  shadowBlur: 6,
                  shadowOffsetX: 3,
                  shadowColor: "rgba(255,255,255,0.54)",
                },
            },
            label: {
                normal: {
                  width: 62,
                  height: 20,
                  distance: 20,
                  fontSize: 13,
                  // fontWeight: "bold",
                  align: "center",
                  verticalAlign: "middle",
                  borderRadius: 5,
                  backgroundColor: "#FA7332",
                  show: true,
                  position: "top",
                  formatter: "{c}%",
                  color: "#fff",
                },
            },
            data: seriesData[1],
          }
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
